module.exports = __webpack_public_path__ + "static/media/29.8a3b090a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/29.png
// module id = 989
// module chunks = 0